"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = require("draft-js");
function isCurrentEntityLink(editorState) {
    if (!editorState) {
        return false;
    }
    var sel = editorState.getSelection();
    var content = editorState.getCurrentContent();
    var contentBlock = content.getBlockForKey(sel.getStartKey());
    var entityKey = contentBlock.getEntityAt(sel.getStartOffset());
    if (!entityKey) {
        return false;
    }
    var entityType = content.getEntity(entityKey).getType();
    return entityType && entityType.toUpperCase() === 'LINK';
}
exports.isCurrentEntityLink = isCurrentEntityLink;
function getCurrentEntityLinkUrl(editorState) {
    if (!editorState) {
        return null;
    }
    var sel = editorState.getSelection();
    var content = editorState.getCurrentContent();
    var contentBlock = content.getBlockForKey(sel.getStartKey());
    var entityKey = contentBlock.getEntityAt(sel.getStartOffset());
    if (!entityKey) {
        return null;
    }
    var entity = content.getEntity(entityKey);
    var entityType = entity.getType();
    if (entityType && entityType.toUpperCase() === 'LINK') {
        var url = entity.getData().url;
        return url;
    }
    return null;
}
exports.getCurrentEntityLinkUrl = getCurrentEntityLinkUrl;
function createOrUpdateLinkEntity(editorState, url) {
    if (!editorState) {
        return null;
    }
    var sel = editorState.getSelection();
    var content = editorState.getCurrentContent();
    if (isCurrentEntityLink(editorState)) {
        var entityKey = content.getBlockForKey(sel.getStartKey()).getEntityAt(sel.getStartOffset());
        var newContent = content.mergeEntityData(entityKey, {
            url: url
        });
        return draft_js_1.EditorState.push(editorState, newContent, 'apply-entity');
    }
    else {
        var contentWithEntity = content.createEntity('LINK', 'MUTABLE', { url: url });
        var entityKey = contentWithEntity.getLastCreatedEntityKey();
        var contentStateWithLink = draft_js_1.Modifier.applyEntity(contentWithEntity, sel, entityKey);
        return draft_js_1.EditorState.push(editorState, contentStateWithLink, 'apply-entity');
    }
}
exports.createOrUpdateLinkEntity = createOrUpdateLinkEntity;
function removeLinkEntity(editorState) {
    if (!editorState) {
        return null;
    }
    var sel = editorState.getSelection();
    var content = editorState.getCurrentContent();
    var contentBlock = content.getBlockForKey(sel.getStartKey());
    var entityKey = contentBlock.getEntityAt(sel.getStartOffset());
    if (!entityKey) {
        return editorState;
    }
    var entity = content.getEntity(entityKey);
    var entityType = entity.getType();
    if (entityType && entityType.toUpperCase() === 'LINK') {
        contentBlock.findEntityRanges(function (value) {
            return !!value.getEntity();
        }, function (start, end) {
            if (start <= sel.getStartOffset() && end >= sel.getStartOffset()) {
                var newSel = sel.merge({
                    focusOffset: end,
                    anchorOffset: start
                });
                var newContent = draft_js_1.Modifier.applyEntity(content, newSel, null);
                editorState = draft_js_1.EditorState.push(editorState, newContent, 'apply-entity');
            }
        });
    }
    return editorState;
}
exports.removeLinkEntity = removeLinkEntity;
function findLinkEntityRanges(contentBlock, callback) {
    if (!contentBlock) {
        return;
    }
    contentBlock.findEntityRanges(function (value) {
        var entityKey = value.getEntity();
        if (entityKey) {
            var entity = draft_js_1.Entity.get(entityKey);
            if (entity) {
                return entity.getType().toUpperCase() === 'LINK';
            }
        }
        return false;
    }, callback);
}
exports.findLinkEntityRanges = findLinkEntityRanges;
